import { Instagram, Twitter, Facebook, Youtube } from "lucide-react";
import { getPlaceholderImage } from "../utils/helpers";

// ─── Navbar ──────────────────────────────────────────────────────────────────
export const NAV_LINKS = [
  { name: "Home", id: "home" },
  { name: "About us", id: "about" },
  { name: "Contact us", id: "contact" },
  { name: "FAQ", id: "faq" },
  { name: "Trip Suggestions", id: "suggestions" },
  { name: "Blog", id: "blog" },
];

// ─── Hero Section ───────────────────────────────────────────────────────────
export const HERO_IMAGE = "./img/trip-suggestions/Backgroundimage21.svg";

export const HERO_AVATARS = [
  "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&auto=format&fit=crop&q=80",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&auto=format&fit=crop&q=80",
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&auto=format&fit=crop&q=80",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&auto=format&fit=crop&q=80",
];

export const HERO_FEATURES = [
  // {
  //   iconSrc: "./img/trip-suggestions/Verified-Travelers.svg",
  //   title: "Verified Travelers",
  //   subtitle: "100% verified profiles",
  // },
  {
    iconSrc: "./img/trip-suggestions/Safe-Secure.svg",
    title: "Safe & Secure",
    subtitle: "Your safety is our priority",
  },
  {
    iconSrc: "./img/trip-suggestions/Real-Connections.svg",
    title: "Real Connections",
    subtitle: "Meaningful friendships",
  },
  {
    iconSrc: "./img/trip-suggestions/Amazing-Destinations.svg",
    title: "Amazing Destinations",
    subtitle: "Handpicked for you",
  },
];

// ─── Explore Section (destination categories & cities) ─────────────────────
const CATEGORIES = [
  {
    id: "india",
    label: "India",
    sublabel: "Explore Bharat",
    image: getPlaceholderImage("india-cat", 400, 300),
    default: {
      name: "Incredible India",
      location: "India",
      image: getPlaceholderImage("india-default", 1200, 700),
      gallery: [getPlaceholderImage("india-g1"), getPlaceholderImage("india-g2"), getPlaceholderImage("india-g3")],
      about:
        "India is a land of diverse cultures, breathtaking landscapes, ancient temples, and vibrant cities. From the snow-capped Himalayas in the north to sun-kissed beaches in the south, every corner of India has a unique story to tell.",
      bestTime: "October to March",
      highlights: ["Himalayas", "Beaches", "Culture", "Cuisine", "Festivals"],
    },
    cities: [
      {
        name: "Manali",
        location: "Himachal Pradesh, India",
        image: getPlaceholderImage("manali", 1200, 700),
        gallery: [getPlaceholderImage("manali-1"), getPlaceholderImage("manali-2"), getPlaceholderImage("manali-3")],
        about:
          "Manali is a high-altitude Himalayan resort town in Himachal Pradesh. It's known for its stunning mountain scenery, snow-capped peaks, adventure sports, and the famous Rohtang Pass. The Beas River flows through the town, adding to its charm.",
        bestTime: "October to June",
        highlights: ["Rohtang Pass", "Solang Valley", "River Rafting", "Snow Sports", "Hadimba Temple"],
      },
      {
        name: "Mussoorie",
        location: "Uttarakhand, India",
        image: getPlaceholderImage("mussoorie", 1200, 700),
        gallery: [getPlaceholderImage("mussoorie-1"), getPlaceholderImage("mussoorie-2"), getPlaceholderImage("mussoorie-3")],
        about:
          "Known as the 'Queen of Hills', Mussoorie is a beautiful hill station nestled in the foothills of the Garhwal Himalayan range. With its colonial architecture, cascading waterfalls, and panoramic views of the Doon Valley, it's a perfect escape.",
        bestTime: "March to June, September to November",
        highlights: ["Gun Hill", "Kempty Falls", "Mall Road", "Lal Tibba", "Cloud's End"],
      },
      {
        name: "Rishikesh",
        location: "Uttarakhand, India",
        image: getPlaceholderImage("rishikesh", 1200, 700),
        gallery: [getPlaceholderImage("rishikesh-1"), getPlaceholderImage("rishikesh-2"), getPlaceholderImage("rishikesh-3")],
        about:
          "Rishikesh, the 'Yoga Capital of the World', sits at the foothills of the Himalayas where the sacred Ganga River flows. It's a spiritual hub offering yoga, meditation, white-water rafting, bungee jumping, and the iconic Laxman Jhula bridge.",
        bestTime: "September to November, February to May",
        highlights: ["Ganga Aarti", "White Water Rafting", "Yoga & Meditation", "Laxman Jhula", "Bungee Jumping"],
      },
      {
        name: "Goa",
        location: "Goa, India",
        image: getPlaceholderImage("goa", 1200, 700),
        gallery: [getPlaceholderImage("goa-1"), getPlaceholderImage("goa-2"), getPlaceholderImage("goa-3")],
        about:
          "India's smallest state packs in golden beaches, Portuguese heritage, vibrant nightlife, and some of the best seafood in the country. From the packed sands of Baga to the quiet coves of Palolem, Goa has a beach for every traveler.",
        bestTime: "November to February",
        highlights: ["Beach Parties", "Water Sports", "Portuguese Heritage", "Nightlife", "Seafood"],
      },
      {
        name: "Delhi",
        location: "New Delhi, India",
        image: getPlaceholderImage("delhi", 1200, 700),
        gallery: [getPlaceholderImage("delhi-1"), getPlaceholderImage("delhi-2"), getPlaceholderImage("delhi-3")],
        about:
          "India's capital is a thrilling blend of ancient history and modern life. Mughal monuments like Red Fort and Humayun's Tomb stand beside busy markets like Chandni Chowk, while Connaught Place and Hauz Khas Village offer modern dining and nightlife.",
        bestTime: "October to March",
        highlights: ["Red Fort", "Qutub Minar", "Chandni Chowk", "India Gate", "Street Food"],
      },
      {
        name: "Mumbai",
        location: "Maharashtra, India",
        image: getPlaceholderImage("mumbai", 1200, 700),
        gallery: [getPlaceholderImage("mumbai-1"), getPlaceholderImage("mumbai-2"), getPlaceholderImage("mumbai-3")],
        about:
          "The 'City of Dreams' is India's financial and entertainment capital. Gateway of India, Marine Drive, Bollywood studios, and world-class restaurants define this city that never sleeps. Mumbai's spirit is infectious and its energy unmatched.",
        bestTime: "November to February",
        highlights: ["Gateway of India", "Marine Drive", "Bollywood", "Street Food", "Elephanta Caves"],
      },
    ],
  },
  {
    id: "hidden-gems",
    label: "Hidden Gems",
    sublabel: "Offbeat Spots",
    image: getPlaceholderImage("hidden-gems-cat", 400, 300),
    default: {
      name: "Hidden Gems",
      location: "World",
      image: getPlaceholderImage("hidden-default", 1200, 700),
      gallery: [getPlaceholderImage("hidden-g1"), getPlaceholderImage("hidden-g2"), getPlaceholderImage("hidden-g3")],
      about:
        "Escape the crowds and discover the world's best-kept secrets. From surreal blue cities to lakeside villages, these offbeat destinations reward the curious traveler with unforgettable experiences away from the tourist trail.",
      bestTime: "Varies by destination",
      highlights: ["Offbeat", "Uncrowded", "Photography", "Adventure", "Culture"],
    },
    cities: [
      {
        name: "El Nido - Palawan",
        location: "El Nido, Philippines",
        image: getPlaceholderImage("el-nido", 1200, 700),
        gallery: [getPlaceholderImage("el-nido-1"), getPlaceholderImage("el-nido-2"), getPlaceholderImage("el-nido-3")],
        about:
          "Turquoise lagoons, towering limestone cliffs and postcard beaches make El Nido one of the most photographed corners of the Philippines. Island-hopping boat tours reveal hidden coves that are only reachable by water.",
        bestTime: "December to May",
        highlights: ["Island Hopping", "Snorkeling", "Limestone Cliffs", "Hidden Lagoons"],
      },
      {
        name: "Chefchaouen",
        location: "Chefchaouen, Morocco",
        image: getPlaceholderImage("chefchaouen", 1200, 700),
        gallery: [getPlaceholderImage("chefchaouen-1"), getPlaceholderImage("chefchaouen-2"), getPlaceholderImage("chefchaouen-3")],
        about:
          "Tucked into the Rif Mountains, this old medina is painted almost entirely in shades of blue, from doorways to stone stairways. Wandering its quiet lanes feels like stepping into a watercolor painting.",
        bestTime: "March to May, September to November",
        highlights: ["Blue Medina", "Mountain Views", "Local Crafts", "Rooftop Cafes"],
      },
      {
        name: "Hallstatt",
        location: "Hallstatt, Austria",
        image: getPlaceholderImage("hallstatt", 1200, 700),
        gallery: [getPlaceholderImage("hallstatt-1"), getPlaceholderImage("hallstatt-2"), getPlaceholderImage("hallstatt-3")],
        about:
          "A lakeside village of pastel houses set against alpine peaks, Hallstatt has been mined for salt since the Bronze Age. A funicular ride up to the Skywalk gives sweeping views over the lake.",
        bestTime: "May to September",
        highlights: ["Alpine Lake", "Salt Mines", "Skywalk", "Historic Village"],
      },
    ],
  },
  {
    id: "iconic-landmarks",
    label: "Iconic",
    sublabel: "Landmarks",
    image: getPlaceholderImage("iconic-landmarks-cat", 400, 300),
    default: {
      name: "Iconic Landmarks",
      location: "World",
      image: getPlaceholderImage("landmark-default", 1200, 700),
      gallery: [getPlaceholderImage("landmark-g1"), getPlaceholderImage("landmark-g2"), getPlaceholderImage("landmark-g3")],
      about:
        "Some places transcend geography and become symbols of human achievement. These iconic landmarks draw millions of visitors every year, each offering a unique window into history, art, and the ambition of civilization.",
      bestTime: "Varies by destination",
      highlights: ["UNESCO Sites", "History", "Architecture", "Photography", "Culture"],
    },
    cities: [
      {
        name: "Taj Mahal",
        location: "Agra, India",
        image: getPlaceholderImage("taj-mahal", 1200, 700),
        gallery: [getPlaceholderImage("taj-mahal-1"), getPlaceholderImage("taj-mahal-2"), getPlaceholderImage("taj-mahal-3")],
        about:
          "This ivory-marble mausoleum was built by Emperor Shah Jahan as a tribute to his wife, and its symmetry is best appreciated at sunrise when the crowds are thin. The surrounding gardens and reflecting pools frame the dome perfectly.",
        bestTime: "October to March",
        highlights: ["UNESCO Site", "Sunrise Views", "Mughal Architecture", "Gardens"],
      },
      {
        name: "Eiffel Tower",
        location: "Paris, France",
        image: getPlaceholderImage("eiffel-tower", 1200, 700),
        gallery: [getPlaceholderImage("eiffel-tower-1"), getPlaceholderImage("eiffel-tower-2"), getPlaceholderImage("eiffel-tower-3")],
        about:
          "The iron lattice tower that once drew criticism from Parisians is now the city's most recognized silhouette, especially when it sparkles on the hour after dark. The summit deck offers views that stretch across the Seine.",
        bestTime: "April to June, September to October",
        highlights: ["City Views", "Evening Sparkle", "Seine River", "Iconic Landmark"],
      },
      {
        name: "Machu Picchu",
        location: "Cusco Region, Peru",
        image: getPlaceholderImage("machu-picchu", 1200, 700),
        gallery: [getPlaceholderImage("machu-picchu-1"), getPlaceholderImage("machu-picchu-2"), getPlaceholderImage("machu-picchu-3")],
        about:
          "Perched high in the Andes, this 15th-century Inca citadel was rediscovered by the outside world only a century ago and still feels remarkably intact. Sunrise hikes along the Inca Trail lead straight to its terraced ruins.",
        bestTime: "May to September",
        highlights: ["Inca Ruins", "Andes Trekking", "Sunrise Hike", "UNESCO Site"],
      },
    ],
  },
  {
    id: "vibrant-cities",
    label: "Vibrant",
    sublabel: "Cities",
    image: getPlaceholderImage("vibrant-cities-cat", 400, 300),
    default: {
      name: "Vibrant Cities",
      location: "World",
      image: getPlaceholderImage("cities-default", 1200, 700),
      gallery: [getPlaceholderImage("cities-g1"), getPlaceholderImage("cities-g2"), getPlaceholderImage("cities-g3")],
      about:
        "The world's most electric cities pulse with street food, art, music, and history. Whether it's the ancient alleys of Hanoi, the Zen temples of Kyoto, or the chaotic souks of Marrakech — vibrant cities promise a sensory overload.",
      bestTime: "Varies by destination",
      highlights: ["Street Food", "Culture", "Nightlife", "Architecture", "Markets"],
    },
    cities: [
      {
        name: "Hanoi",
        location: "Hanoi, Vietnam",
        image: getPlaceholderImage("hanoi", 1200, 700),
        gallery: [getPlaceholderImage("hanoi-1"), getPlaceholderImage("hanoi-2"), getPlaceholderImage("hanoi-3")],
        about:
          "Hanoi layers a French colonial old quarter over a thousand-year-old capital, with motorbikes, street-side pho stalls and Hoan Kiem Lake all sharing the same narrow streets. Evenings bring water puppet shows and lantern-lit alleys.",
        bestTime: "October to December, March to April",
        highlights: ["Old Quarter", "Street Food", "Hoan Kiem Lake", "Water Puppetry"],
      },
      {
        name: "Kyoto",
        location: "Kyoto, Japan",
        image: getPlaceholderImage("kyoto", 1200, 700),
        gallery: [getPlaceholderImage("kyoto-1"), getPlaceholderImage("kyoto-2"), getPlaceholderImage("kyoto-3")],
        about:
          "Japan's former imperial capital holds thousands of temples and shrines, from the vermillion gates of Fushimi Inari to the raked gravel of Zen rock gardens. Cherry blossoms and maple leaves turn the city into a seasonal spectacle twice a year.",
        bestTime: "March to May, October to November",
        highlights: ["Ancient Temples", "Cherry Blossoms", "Zen Gardens", "Geisha District"],
      },
      {
        name: "Marrakech",
        location: "Marrakech, Morocco",
        image: getPlaceholderImage("marrakech", 1200, 700),
        gallery: [getPlaceholderImage("marrakech-1"), getPlaceholderImage("marrakech-2"), getPlaceholderImage("marrakech-3")],
        about:
          "The Red City's medina is a maze of souks, spice stalls and riads hidden behind unmarked doors, all centered on the ever-changing energy of Jemaa el-Fnaa square. Rooftop terraces offer a quieter view once the sun goes down.",
        bestTime: "March to May, September to November",
        highlights: ["Medina Souks", "Jemaa el-Fnaa", "Riad Courtyards", "Spice Markets"],
      },
    ],
  },
  {
    id: "island-escapes",
    label: "Island",
    sublabel: "Escapes",
    image: getPlaceholderImage("island-escapes-cat", 400, 300),
    default: {
      name: "Island Escapes",
      location: "World",
      image: getPlaceholderImage("island-default", 1200, 700),
      gallery: [getPlaceholderImage("island-g1"), getPlaceholderImage("island-g2"), getPlaceholderImage("island-g3")],
      about:
        "Surrounded by turquoise waters, swaying palms, and endless horizons — islands offer the ultimate getaway. Whether it's the romance of Santorini's sunsets or the raw reef of Bora Bora, island escapes are pure paradise.",
      bestTime: "Varies by destination",
      highlights: ["Beaches", "Snorkeling", "Sunsets", "Water Sports", "Relaxation"],
    },
    cities: [
      {
        name: "Santorini",
        location: "Santorini, Greece",
        image: getPlaceholderImage("santorini", 1200, 700),
        gallery: [getPlaceholderImage("santorini-1"), getPlaceholderImage("santorini-2"), getPlaceholderImage("santorini-3")],
        about:
          "Whitewashed villages cling to the rim of a volcanic caldera, with blue-domed churches framing some of the most photographed sunsets in the Mediterranean. Wine tastings on the island's black-sand slopes are a local specialty.",
        bestTime: "April to June, September to October",
        highlights: ["Caldera Views", "Sunset Watching", "Volcanic Beaches", "Wine Tasting"],
      },
      {
        name: "Bora Bora",
        location: "Bora Bora, French Polynesia",
        image: getPlaceholderImage("bora-bora", 1200, 700),
        gallery: [getPlaceholderImage("bora-bora-1"), getPlaceholderImage("bora-bora-2"), getPlaceholderImage("bora-bora-3")],
        about:
          "An extinct volcano ringed by a coral reef and impossibly clear lagoon, Bora Bora is where overwater bungalows were practically invented. Snorkeling here means swimming alongside reef sharks and rays in waist-deep water.",
        bestTime: "May to October",
        highlights: ["Overwater Bungalows", "Coral Reef", "Lagoon Snorkeling", "Mount Otemanu"],
      },
      {
        name: "Bali",
        location: "Bali, Indonesia",
        image: getPlaceholderImage("bali", 1200, 700),
        gallery: [getPlaceholderImage("bali-1"), getPlaceholderImage("bali-2"), getPlaceholderImage("bali-3")],
        about:
          "Rice terraces, cliffside temples and surf breaks share the island with a growing wellness scene centered on Ubud. Balinese Hindu ceremonies happen year-round and are woven into daily life across the island.",
        bestTime: "April to October",
        highlights: ["Rice Terraces", "Cliffside Temples", "Surf Beaches", "Wellness Retreats"],
      },
    ],
  },
  {
    id: "mountain-retreats",
    label: "Mountain",
    sublabel: "Retreats",
    image: getPlaceholderImage("mountain-retreats-cat", 400, 300),
    default: {
      name: "Mountain Retreats",
      location: "World",
      image: getPlaceholderImage("mountain-default", 1200, 700),
      gallery: [getPlaceholderImage("mountain-g1"), getPlaceholderImage("mountain-g2"), getPlaceholderImage("mountain-g3")],
      about:
        "High above the noise of everyday life, mountain retreats offer crisp air, dramatic scenery, and the thrill of adventure. From the Swiss Alps to the Canadian Rockies, these peaks call to those who seek both serenity and excitement.",
      bestTime: "June to September",
      highlights: ["Alpine Views", "Trekking", "Adventure Sports", "Wildlife", "Scenic Railways"],
    },
    cities: [
      {
        name: "Interlaken",
        location: "Interlaken, Switzerland",
        image: getPlaceholderImage("interlaken", 1200, 700),
        gallery: [getPlaceholderImage("interlaken-1"), getPlaceholderImage("interlaken-2"), getPlaceholderImage("interlaken-3")],
        about:
          "Sitting between two turquoise lakes and beneath a ring of snow-capped peaks, Interlaken is the launch point for paragliding, cog railways and hikes into the Jungfrau region. It's an adrenaline hub with an alpine backdrop.",
        bestTime: "June to September",
        highlights: ["Alpine Peaks", "Paragliding", "Lake Views", "Jungfrau Railway"],
      },
      {
        name: "Banff",
        location: "Banff, Canada",
        image: getPlaceholderImage("banff", 1200, 700),
        gallery: [getPlaceholderImage("banff-1"), getPlaceholderImage("banff-2"), getPlaceholderImage("banff-3")],
        about:
          "Glacier-fed lakes in shades of impossible turquoise sit inside Canada's oldest national park, ringed by the jagged peaks of the Canadian Rockies. Wildlife sightings, from elk to grizzly bears, are part of everyday driving here.",
        bestTime: "June to September",
        highlights: ["Glacier Lakes", "Rocky Mountains", "Wildlife Viewing", "Hiking Trails"],
      },
      {
        name: "Queenstown",
        location: "Queenstown, New Zealand",
        image: getPlaceholderImage("queenstown", 1200, 700),
        gallery: [getPlaceholderImage("queenstown-1"), getPlaceholderImage("queenstown-2"), getPlaceholderImage("queenstown-3")],
        about:
          "Set on the shores of Lake Wakatipu beneath the Remarkables mountain range, Queenstown built its reputation as the birthplace of commercial bungee jumping. It's equally suited to a quiet lakeside walk or a full day of adventure sports.",
        bestTime: "December to February, June to August",
        highlights: ["Bungee Jumping", "Lake Wakatipu", "Remarkables Range", "Adventure Sports"],
      },
    ],
  },
  {
    id: "desert-adventures",
    label: "Desert",
    sublabel: "Adventures",
    image: getPlaceholderImage("desert-cat", 400, 300),
    default: {
      name: "Desert Adventures",
      location: "World",
      image: getPlaceholderImage("desert-default", 1200, 700),
      gallery: [getPlaceholderImage("desert-g1"), getPlaceholderImage("desert-g2"), getPlaceholderImage("desert-g3")],
      about:
        "Endless dunes, star-filled skies and the quiet of open sand make desert regions some of the most striking landscapes on earth. Camel treks, dune bashing and desert camps turn a barren horizon into an unforgettable adventure.",
      bestTime: "October to March",
      highlights: ["Dune Bashing", "Camel Trekking", "Desert Camps", "Stargazing"],
    },
    cities: [
      {
        name: "Dubai Desert",
        location: "Dubai, UAE",
        image: getPlaceholderImage("dubai-desert", 1200, 700),
        gallery: [getPlaceholderImage("dubai-desert-1"), getPlaceholderImage("dubai-desert-2"), getPlaceholderImage("dubai-desert-3")],
        about:
          "Minutes from Dubai's skyline, the Arabian desert unfolds into rolling red dunes. Dune-bashing safaris, falconry shows and Bedouin-style camps under the stars offer a sharp contrast to the city's glass towers.",
        bestTime: "November to March",
        highlights: ["Dune Bashing", "Bedouin Camps", "Falconry", "Sandboarding"],
      },
      {
        name: "Jaisalmer",
        location: "Rajasthan, India",
        image: getPlaceholderImage("jaisalmer", 1200, 700),
        gallery: [getPlaceholderImage("jaisalmer-1"), getPlaceholderImage("jaisalmer-2"), getPlaceholderImage("jaisalmer-3")],
        about:
          "The 'Golden City' rises from the Thar Desert in a fortress of honey-colored sandstone. Camel safaris into the surrounding dunes and nights spent camping under open skies make Jaisalmer a desert classic.",
        bestTime: "October to March",
        highlights: ["Jaisalmer Fort", "Camel Safari", "Sam Sand Dunes", "Havelis"],
      },
      {
        name: "Wadi Rum",
        location: "Wadi Rum, Jordan",
        image: getPlaceholderImage("wadi-rum", 1200, 700),
        gallery: [getPlaceholderImage("wadi-rum-1"), getPlaceholderImage("wadi-rum-2"), getPlaceholderImage("wadi-rum-3")],
        about:
          "Known as the Valley of the Moon, Wadi Rum's towering red rock formations and vast open desert have drawn filmmakers and travelers alike. Overnight stays in Bedouin camps come with some of the clearest night skies anywhere.",
        bestTime: "March to May, September to November",
        highlights: ["Rock Formations", "Bedouin Camps", "Stargazing", "Jeep Tours"],
      },
    ],
  },
  {
    id: "wildlife-safaris",
    label: "Wildlife",
    sublabel: "Safaris",
    image: getPlaceholderImage("wildlife-cat", 400, 300),
    default: {
      name: "Wildlife Safaris",
      location: "World",
      image: getPlaceholderImage("wildlife-default", 1200, 700),
      gallery: [getPlaceholderImage("wildlife-g1"), getPlaceholderImage("wildlife-g2"), getPlaceholderImage("wildlife-g3")],
      about:
        "From the open plains of Africa to the jungles of South Asia, safari destinations bring travelers face to face with the natural world at its most dramatic. Early morning game drives and expert trackers make every sighting count.",
      bestTime: "Varies by destination",
      highlights: ["Game Drives", "Big Cats", "National Parks", "Birdwatching"],
    },
    cities: [
      {
        name: "Maasai Mara",
        location: "Maasai Mara, Kenya",
        image: getPlaceholderImage("maasai-mara", 1200, 700),
        gallery: [getPlaceholderImage("maasai-mara-1"), getPlaceholderImage("maasai-mara-2"), getPlaceholderImage("maasai-mara-3")],
        about:
          "Home to the Great Migration, the Maasai Mara draws travelers hoping to see wildebeest and zebra cross crocodile-filled rivers in their millions. Lions, elephants and cheetahs roam the open savannah year-round.",
        bestTime: "July to October",
        highlights: ["Great Migration", "Big Five", "Hot Air Balloon Safari", "Maasai Culture"],
      },
      {
        name: "Ranthambore",
        location: "Rajasthan, India",
        image: getPlaceholderImage("ranthambore", 1200, 700),
        gallery: [getPlaceholderImage("ranthambore-1"), getPlaceholderImage("ranthambore-2"), getPlaceholderImage("ranthambore-3")],
        about:
          "One of India's best places to spot a wild tiger, Ranthambore National Park pairs dense forest and rocky terrain with the ruins of a 10th-century fort rising above the tree line.",
        bestTime: "October to April",
        highlights: ["Tiger Sightings", "Jeep Safari", "Ranthambore Fort", "Bird Species"],
      },
      {
        name: "Kruger National Park",
        location: "Kruger, South Africa",
        image: getPlaceholderImage("kruger", 1200, 700),
        gallery: [getPlaceholderImage("kruger-1"), getPlaceholderImage("kruger-2"), getPlaceholderImage("kruger-3")],
        about:
          "One of Africa's largest game reserves, Kruger is home to the Big Five and hundreds of other species. Self-drive routes and guided night drives both offer close encounters with the park's wildlife.",
        bestTime: "May to September",
        highlights: ["Big Five", "Self-Drive Safari", "Night Drives", "Bushveld Camps"],
      },
    ],
  },
  {
    id: "cultural-heritage",
    label: "Cultural",
    sublabel: "Heritage",
    image: getPlaceholderImage("cultural-cat", 400, 300),
    default: {
      name: "Cultural Heritage",
      location: "World",
      image: getPlaceholderImage("cultural-default", 1200, 700),
      gallery: [getPlaceholderImage("cultural-g1"), getPlaceholderImage("cultural-g2"), getPlaceholderImage("cultural-g3")],
      about:
        "Ancient temples, ruined cities and living traditions passed down for centuries make cultural heritage destinations some of the richest places to travel. These sites connect visitors to history that still shapes the present.",
      bestTime: "Varies by destination",
      highlights: ["Ancient Ruins", "Local Traditions", "Historic Architecture", "Museums"],
    },
    cities: [
      {
        name: "Kyoto",
        location: "Kyoto, Japan",
        image: getPlaceholderImage("kyoto", 1200, 700),
        gallery: [getPlaceholderImage("kyoto-1"), getPlaceholderImage("kyoto-2"), getPlaceholderImage("kyoto-3")],
        about:
          "Japan's former imperial capital is home to thousands of temples and shrines, from the golden Kinkaku-ji to the endless red gates of Fushimi Inari. Traditional geisha districts and quiet gardens preserve centuries of history.",
        bestTime: "March to May, September to November",
        highlights: ["Fushimi Inari", "Kinkaku-ji", "Gion District", "Bamboo Grove"],
      },
      {
        name: "Petra",
        location: "Petra, Jordan",
        image: getPlaceholderImage("petra", 1200, 700),
        gallery: [getPlaceholderImage("petra-1"), getPlaceholderImage("petra-2"), getPlaceholderImage("petra-3")],
        about:
          "Carved directly into rose-colored rock over 2,000 years ago, Petra is reached through a narrow canyon that opens dramatically onto the Treasury. It remains one of the ancient world's most striking archaeological sites.",
        bestTime: "March to May, September to November",
        highlights: ["The Treasury", "Siq Canyon", "Monastery Hike", "Ancient Tombs"],
      },
      {
        name: "Varanasi",
        location: "Uttar Pradesh, India",
        image: getPlaceholderImage("varanasi", 1200, 700),
        gallery: [getPlaceholderImage("varanasi-1"), getPlaceholderImage("varanasi-2"), getPlaceholderImage("varanasi-3")],
        about:
          "One of the world's oldest continuously inhabited cities, Varanasi sits on the banks of the Ganges where daily rituals, cremation ceremonies and evening Aarti have continued for thousands of years.",
        bestTime: "October to March",
        highlights: ["Ganga Aarti", "Boat Rides", "Ancient Temples", "Old City Alleys"],
      },
    ],
  },
];

export { CATEGORIES };

// ─── Blog Hero ───────────────────────────────────────────────────────────────
export const BLOG_HERO_AVATARS = [
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&auto=format&fit=crop&q=80",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&auto=format&fit=crop&q=80",
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&auto=format&fit=crop&q=80",
  "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&auto=format&fit=crop&q=80",
];

// ─── Blog Featured Posts ────────────────────────────────────────────────────
export const BLOG_AVATAR_AUTHOR =
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&auto=format&fit=crop&q=80";

export const BLOG_LIST_POSTS = [
  {
    id: 1,
    tag: "Travel Tips",
    title: "Essential Solo Travel Tips for First-Time Travelers",
    desc: "Practical tips to help you plan, stay safe, and enjoy your first solo adventure with confidence...",
    date: "May 20, 2026",
    readTime: "8 min read",
    image:
      "https://images.unsplash.com/photo-1501555088652-021faa106b9b?w=600&auto=format&fit=crop&q=80",
  },
  {
    id: 2,
    tag: "Travel Tips",
    title: "Essential Solo Travel Tips for First-Time Travelers",
    desc: "Practical tips to help you plan, stay safe, and enjoy your first solo adventure with confidence...",
    date: "May 20, 2026",
    readTime: "8 min read",
    image:
      "https://images.unsplash.com/photo-1501555088652-021faa106b9b?w=600&auto=format&fit=crop&q=80",
  },
  {
    id: 3,
    tag: "Travel Tips",
    title: "Essential Solo Travel Tips for First-Time Travelers",
    desc: "Practical tips to help you plan, stay safe, and enjoy your first solo adventure with confidence...",
    date: "May 20, 2026",
    readTime: "8 min read",
    image:
      "https://images.unsplash.com/photo-1501555088652-021faa106b9b?w=600&auto=format&fit=crop&q=80",
  },
];

// ─── Blog Sidebar ────────────────────────────────────────────────────────────
export const BLOG_POPULAR_POSTS = [
  {
    id: 1,
    title: "Essential Solo Travel Tips for First-Time Travelers",
    date: "May 20, 2026",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1501555088652-021faa106b9b?w=200&auto=format&fit=crop&q=80",
  },
  {
    id: 2,
    title: "Essential Solo Travel Tips for First-Time Travelers",
    date: "May 20, 2026",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1501555088652-021faa106b9b?w=200&auto=format&fit=crop&q=80",
  },
  {
    id: 3,
    title: "Essential Solo Travel Tips for First-Time Travelers",
    date: "May 20, 2026",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1501555088652-021faa106b9b?w=200&auto=format&fit=crop&q=80",
  },
];

// ─── Footer ──────────────────────────────────────────────────────────────────
export const FOOTER_LINKS = [
  { label: "Home", href: "#" },
  { label: "About Us", href: "#" },
  { label: "Contact Us", href: "#" },
  { label: "FAQ", href: "#" },
  { label: "Blog", href: "#" },
  { label: "Privacy Policy", href: "#" },
];

export const SOCIAL_LINKS = [
  { icon: Instagram, label: "Instagram", href: "#" },
  { icon: Twitter, label: "Twitter", href: "#" },
  { icon: Facebook, label: "Facebook", href: "#" },
  { icon: Youtube, label: "YouTube", href: "#" },
];
